webpackJsonp([4241802371889],{

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialTableRow = function MaterialTableRow(props) {
	  var tableRowData = props.tableRowData;
	
	  return _react2.default.createElement(
	    _reactMd.TableRow,
	    null,
	    tableRowData.map(function (datum, index) {
	      return _react2.default.createElement(
	        _reactMd.TableColumn,
	        { key: index },
	        datum
	      );
	    })
	  );
	};
	
	var MaterialTable = function MaterialTable(props) {
	  var headElements = props.headElements,
	      rowElements = props.rowElements;
	
	  return _react2.default.createElement(
	    _reactMd.DataTable,
	    { plain: true },
	    _react2.default.createElement(
	      _reactMd.TableHeader,
	      null,
	      _react2.default.createElement(
	        _reactMd.TableRow,
	        null,
	        headElements.map(function (headElement, index) {
	          return _react2.default.createElement(
	            _reactMd.TableColumn,
	            { key: index },
	            headElement
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactMd.TableBody,
	      null,
	      rowElements.map(function (rowElement, index) {
	        return _react2.default.createElement(MaterialTableRow, { tableRowData: rowElement, key: index });
	      })
	    )
	  );
	};
	
	exports.default = MaterialTable;
	module.exports = exports['default'];

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _operationalRelationshipsSplashLow = __webpack_require__(890);
	
	var _operationalRelationshipsSplashLow2 = _interopRequireDefault(_operationalRelationshipsSplashLow);
	
	var _Splash = __webpack_require__(23);
	
	var _Splash2 = _interopRequireDefault(_Splash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  backgroundImage: 'url(' + _operationalRelationshipsSplashLow2.default + ')'
	};
	
	var OperationalRelationshipsSplash = function OperationalRelationshipsSplash() {
	  return _react2.default.createElement(_Splash2.default, { style: style, title: 'Operational Relationships' });
	};
	
	exports.default = OperationalRelationshipsSplash;
	module.exports = exports['default'];

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(13);
	
	__webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TermsModal = function (_PureComponent) {
		_inherits(TermsModal, _PureComponent);
	
		function TermsModal(props) {
			_classCallCheck(this, TermsModal);
	
			var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
			_this.show = function (e) {
				e.preventDefault();
				_this.setState({ visible: true });
			};
	
			_this.hide = function (e) {
				_this.setState({ visible: false });
			};
	
			_this.state = { visible: false };
	
			_this.show = _this.show.bind(_this);
			_this.hide = _this.hide.bind(_this);
			return _this;
		}
	
		TermsModal.prototype.render = function render() {
			var _props = this.props,
			    link = _props.link,
			    text = _props.text;
			var visible = this.state.visible;
	
			var actions = [{
				onClick: this.hide,
				primary: true,
				children: 'Agree and Download File',
				href: link
			}, {
				onClick: this.hide,
				primary: true,
				children: 'Cancel'
			}];
	
			return _react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(
					'a',
					{ href: '#', onClick: this.show },
					text
				),
				_react2.default.createElement(
					_reactMd.DialogContainer,
					{
						id: 'terms-modal',
						visible: visible,
						title: 'Terms & Conditions',
						onHide: this.hide,
						'aria-describedby': 'terms-and-conditions',
						modal: true,
						actions: actions,
						width: '90%'
					},
					_react2.default.createElement(
						'div',
						{ id: 'terms-modal', className: 'md-color--secondary-text' },
						_react2.default.createElement(
							'p',
							null,
							'By using OLLIE, you agree to the following:'
						),
						_react2.default.createElement(
							'h3',
							null,
							'No Legal or Business Advice'
						),
						_react2.default.createElement(
							'p',
							null,
							'The resources found in OLLIE are intended for general informational and educational purposes only. Such materials are for informational purposes only and may not reflect the most current legal developments. These informational materials are not intended, and must not be taken, as legal advice on any particular set of facts or circumstances. You need to contact a lawyer licensed in your jurisdiction for advice on specific legal issues problems.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'No Attorney-Client Relationship Created by Use of this Website'
						),
						_react2.default.createElement(
							'p',
							null,
							'Neither your receipt of information from this website, nor your use of this website to contact the New Business Community Law Clinic (hereinafter \u201Cthe Firm\u201D) or one of its lawyers creates an attorney-client relationship between you and the Firm. You will become a client of the Firm only if and when you sign and engagement agreement setting forth the scope of the Firm\u2019s engagement and other relevant matters. As a matter of policy, the Firm does not accept a new client without first investigating for possible conflicts of interests and obtaining a signed engagement letter. (The Firm may, for example, already represent another party involved in your matter.)'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Links to Third Party Websites'
						),
						_react2.default.createElement(
							'p',
							null,
							'As a convenience, this website provides links to various third-party websites. Such linked websites are not under the control of the Firm, and the Firm assumes no responsibility for the accuracy of the contents of such websites.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Authorized Practice of Law'
						),
						_react2.default.createElement(
							'p',
							null,
							'The Firm does not seek, and this website is not intended to solicit, legal engagements in jurisdictions outside of our lawyers\u2019 states of licensure when such engagements would constitute the unauthorized practice of law in any jurisdiction.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Disclaimer of Warranties'
						),
						_react2.default.createElement(
							'p',
							null,
							'TO THE EXTENT PERMITTED BY LAW, THE DOCUMENTS LINKED IN OLLIE ARE PROVIDED AS-IS WITH NO REPRESENTATIONS OR WARRANTIES, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. TO THE EXTENT PERMITTED BY LAW, YOU ASSUME COMPLETE RESPONSIBILITY AND RISK FOR USE OF OLLIE AND ITS DOCUMENTS.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Limitation of Liability'
						),
						_react2.default.createElement(
							'p',
							null,
							'IN NO EVENT SHALL THE NEW BUSINESS COMMUNITY LAW CLINIC, OR BERKELEY LAW, OR ANY OF ITS AFFILIATES, BE LIABLE FOR ANY DAMAGES RESULTING FROM LOSS OF USE, DATA, OR PROFITS WHETHER DIRECT OR INDIRECT OR FOR ANY INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES, ARISING OUT OF OR IN CONNECTION WITH THE USE OF THE OLLIE WEBSITE, WHETHER OR NOT THE NEW BUSINESS COMMUNITY LAW CLINIC, OR BERKELEY LAW, OR ANY OF ITS AFFILIATES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.'
						)
					)
				)
			);
		};
	
		return TermsModal;
	}(_react.PureComponent);
	
	exports.default = TermsModal;
	module.exports = exports['default'];

/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/operational-relationships-splash-low.1da5f833.jpg";

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactMd = __webpack_require__(13);
	
	var _OperationalRelationshipsSplash = __webpack_require__(374);
	
	var _OperationalRelationshipsSplash2 = _interopRequireDefault(_OperationalRelationshipsSplash);
	
	var _FootnoteIcon = __webpack_require__(35);
	
	var _FootnoteIcon2 = _interopRequireDefault(_FootnoteIcon);
	
	var _FootnotesList = __webpack_require__(36);
	
	var _FootnotesList2 = _interopRequireDefault(_FootnotesList);
	
	var _TableOfContents = __webpack_require__(42);
	
	var _TableOfContents2 = _interopRequireDefault(_TableOfContents);
	
	var _MaterialTable = __webpack_require__(78);
	
	var _MaterialTable2 = _interopRequireDefault(_MaterialTable);
	
	var _TermsModal = __webpack_require__(79);
	
	var _TermsModal2 = _interopRequireDefault(_TermsModal);
	
	var _TopDisclaimer = __webpack_require__(80);
	
	var _TopDisclaimer2 = _interopRequireDefault(_TopDisclaimer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OperationalRelationshipsPage = function OperationalRelationshipsPage() {
	
	  var footnotes = ['For example, terminating someone due to their race is unlawful, and would not be allowed, even in an at-will employment state.', 'An employee who breaches an employment contract could be liable for the cost to cover (the $ spent by the employer to find and hire a replacement), while an employer could be liable for the remaining amount owed under the contract.'];
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'content' },
	    _react2.default.createElement(_OperationalRelationshipsSplash2.default, null),
	    _react2.default.createElement(
	      _reactMd.Card,
	      { className: 'md-block-centered main-content-card' },
	      _react2.default.createElement(
	        _reactMd.CardText,
	        null,
	        _react2.default.createElement(
	          _reactMd.Grid,
	          null,
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 8, style: { margin: 'auto' } },
	            _react2.default.createElement(_TopDisclaimer2.default, null),
	            _react2.default.createElement(_TableOfContents2.default, {
	              contents: [
	              // 'Hiring Overview Video',
	              'Independent Contractors', 'Employees', 'Interns or Volunteers', 'Footnotes']
	            }),
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Hiring employees, independent contractors, and interns'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { id: 'worker-classification', className: 'anchor-ref' },
	              'Worker Classification'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Worker arrangements are where most new businesses get into trouble, so we want to make sure you\'re well-equipped to prevent common mistakes early on.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The government will classify your workers into three buckets:'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Independent Contractors;'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Employees; or'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Volunteers/Unpaid Interns.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Even if ',
	              _react2.default.createElement(
	                'i',
	                null,
	                'you'
	              ),
	              ' don\'t categorize your workers a certain way, the government will. Thus, it\'s very important for you to correctly classify your workers, both to properly protect your IP, and to avoid penalties and fees from the Department of Labor.'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { id: 'independent-contractors', className: 'anchor-ref' },
	              'Independent Contractors'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Hiring independent contractors can be a very efficient way to get what you need done. They\'ll perform a service for you and you don\'t need to pay them minimum wage/overtime, give them benefits, or go through the hassle of withholding part of their wages for Social Security/Medicare contributions. However, you ',
	              _react2.default.createElement(
	                'b',
	                null,
	                'do'
	              ),
	              ' need to make sure you actually treat them like independent contractors\u2014otherwise, the government will classify them as employees, and you might owe a hefty sum in backpay and penalties. Generally speaking, in the government\'s mind, an independent contractor is an expert hired for short-term, clearly defined projects, who is engaged in their own independent business. The more the relationship looks like one where the worker has a specialized set of skills and the employer lacks control of how the work is actually being done, the more likely a court is going to rule that the worker is, in fact, an independent contractor.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'The ABC Test'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'In California, courts will apply the ABC test to determine whether a worker is an independent contractor or an employee. The ABC test puts the burden on the employer to show that the worker:'
	            ),
	            _react2.default.createElement(
	              'ol',
	              { type: 'A' },
	              _react2.default.createElement(
	                'li',
	                null,
	                'is free from the control and direction of the hiring entity in the performance of the work, both under the contract for the performance of the work and in fact;'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'performs work that is outside the usual course of the hiring entity\'s business; and'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'is customarily engaged in an independently established trade, occupation, or business of the same nature as the work performed for the hiring entity'
	              )
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              '(A) Free from Control and Direction'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This prong focuses on the independence of the worker in performing the work. For example, if the employer has the power to set the working hours and direct the procedures for completing the tasks, this indicates that the relationship is more like that of an employer and employee.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Note that a court would also look at which party has ',
	              _react2.default.createElement(
	                'i',
	                null,
	                'necessary'
	              ),
	              ' control over the work performed. If the task can only be performed one way, a court will not consider a lack of supervision over the task to be meaningful to the question of whether the contractor is free from the control or direction of the employer. For example, if an employer controls all of the other operations of a farm, but contracts with workers to harvest crops and pays the workers based on the amount of crops received, a court would still consider the employer to have all of the necessary control over the job. See ',
	              _react2.default.createElement(
	                'i',
	                null,
	                'S.G. Borello Sons v. Department of Industrial Rel'
	              ),
	              ', 769 P.2d 399, 345 (Cal. 1989).'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Other instances where an employer would not satisfy this prong include:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Knitters and sewers who work at home on their own machines at their own pace to produce children\'s clothing based on patterns provided to them by the employer. See ',
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  'Fleece on Earth v. Dep\'t of Employment'
	                ),
	                ', 923 A.2d 594 (Vt. 2007).'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'A truck driver who was required to keep their truck clean, obtain the employer\'s permission before transporting passengers, go to the employer\'s dispatch center to receive additional assignments, and could be terminated for tardiness, failing to contact the dispatch center, or violating any of the employer\'s written policies. See ',
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  'Great N. Constr.'
	                ),
	                ', Inc. v. Dep\'t of Labor, 2016 Vt. 126, (Vt. 2016)'
	              )
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              '(B) Outside the Usual Course of Business'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This prong addresses the question of whether the worker would be reasonably viewed as "working in the hiring entity\'s business." The classic example would be when a retail store calls in a plumber to work on a leaky pipe. The retailer\'s usual course of business is far removed from the plumber\'s repair services, so a reasonable person would not view the plumber to be an employee of the retail store.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'In contrast, courts have found that the following situations fail this prong of the ABC test:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Seamstresses who work from home to create dresses using cloth and patterns supplied by the employer, that will then be sold by the employer. See ',
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  'Silent Woman, Ltd. v. Donovan'
	                ),
	                ', 585 F. Supp. 447 (E.D. Wis. 1984).'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Cake decorators at a bakery who work on a regular basis on the bakery\'s custom-designed cakes. See ',
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  'Dole v. Snell'
	                ),
	                ', 875 F.2d 802 (10th Cir. 1989)'
	              )
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              '(C) Independently Established Business'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Lastly, this prong requires that the worker has independently chosen to go into business for themselves. Factors that would weigh in favor of a contractor relationship include:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'forming an entity (like an LLC or corporation);'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'obtaining a business license;'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'advertising/marketing activity; and'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'regularly offering services to the public or other customers;'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Examples where courts have found that the employer did not satisfy this prong include:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Construction workers who used their own tools, but the employer presented no evidence that they had business cards, business licenses, business phones, business locations, or other clients. See ',
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  'Brothers Const. v. Va. Employment Com\'n'
	                ),
	                ', 494 S.E.2d 478, 288 (Va. Ct. App. 1998).'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Bicycle courier who was contracted to deliver letters and packages for a same-day pickup and delivery service, but the employer presented no evidence that the courier advertised to other potential customers, had their own business cards, had their own clients, or maintained a separate place of business or telephone listing. See ',
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  'Boston B. C. v. D. D., Div., Emp'
	                ),
	                ', 778 N.E.2d 964 (Mass. App. Ct. 2002).'
	              )
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Setting Up an Independent Contractor Relationship'
	            ),
	            _react2.default.createElement(_MaterialTable2.default, { title: 'Setting Up an Independent Contractor Relationship',
	              headElements: ['Level of Compliance', 'Requirements'],
	              rowElements: [['Meets Government Requirements', 'Pass the ABC Test'], ['Minimally Necessary', 'Have a written agreement detailing the terms of the relationship'], ['Optimal', 'Anticipate common issues of risk management, agency, and IP ownership, both in writing and in practice']] }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Template Forms'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'New Business Community Law Clinic: ',
	                _react2.default.createElement(_TermsModal2.default, { link: 'https://drive.google.com/open?id=0B9zW8ghngOP2MTdBQVZUOGlMVjQ', text: 'Template - Independent Contractor Agreement' })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Orrick: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.orrick.com/Total-Access/Tool-Kit/Start-Up-Forms/Employment-and-Consultant', target: '_blank', rel: 'noopener noreferrer' },
	                  'Startup Forms Library - Consulting Agreement'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Nolo (via SF Law Library: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://sflawlibrary.org/legal-databases#Nolo%20Legal%20Information%20Reference%20Center', target: '_blank', rel: 'noopener noreferrer' },
	                  'Nolo Legal Information Reference Center - Consultant & Independent Contractor Agreements'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              { id: 'employees', className: 'anchor-ref' },
	              'Employees'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'At-Will Employment vs. Employment Contract'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'While we would always recommend having a written contract between you and your independent contractors, you probably don\'t want to enter into an employment contract with your employees. California, like most states, is an at-will employment state, where the default case is that both the employer and the employee are allowed to terminate the relationship at any time, for any (lawful) reason. ',
	              _react2.default.createElement(_FootnoteIcon2.default, { footnotes: footnotes, number: 1 })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Instead, what you would want to provide is an offer letter, detailing the terms of the employment while leaving open-ended its length. Otherwise, termination prior to the end date of the contract may result in damages. ',
	              _react2.default.createElement(_FootnoteIcon2.default, { footnotes: footnotes, number: 2 }),
	              ' However, this might be an intended result if you\'re looking to recruit a highly skilled and highly compensated worker (e.g., a CEO).'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Legal Compliance Checklist'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'i',
	                null,
	                'From the ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://insightcced.org/', target: '_blank', rel: 'noopener noreferrer' },
	                  'Insight Center for Community Economic Development'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'All employers should regularly assess their compliance with legal requirements, including the following:'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer has ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://sa.www4.irs.gov/modiein/individual/index.jsp', target: '_blank', rel: 'noopener noreferrer' },
	                  'applied for'
	                ),
	                ' and been assigned a federal employer identification number by the Internal Revenue Service (IRS).'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer has registered with the California Employment Development Department (EDD) and secured an EDD account number. See \u201CHow to Register with the EDD\u201D and \u201CEmployer Payroll Tax Account Number\u201D ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://www.edd.ca.gov/Payroll_Taxes/Am_I_Required_to_Register_as_an_Employer.htm', target: '_blank', rel: 'noopener noreferrer' },
	                  'here'
	                ),
	                '.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer withholds federal and state income taxes and federal social security, (FICA) taxes from taxable wages paid to employees, pays the employer share of FICA taxes, and deposits all such funds in a timely manner and with the appropriate IRS and EDD forms. For information on California payroll taxes, click ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://www.edd.ca.gov/Payroll_Taxes/', target: '_blank', rel: 'noopener noreferrer' },
	                  'here'
	                ),
	                '.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer withholds state disability insurance from taxable wages paid to employees, and deposits all such funds in a timely manner with EDD, or establishes a state-approved private disability insurance plan. For information on California disability insurance, click ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://www.edd.ca.gov/disability/Employers_and_Self-Employed_Information.htm', target: '_blank', rel: 'noopener noreferrer' },
	                  'here'
	                ),
	                '.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer purchases workers\u2019 compensation insurance through an authorized insurance company or from the State, or secures consent to self-insure.  If the business has volunteers, the leadership has declared that the business\u2019s volunteers are employees for workers\u2019 compensation purposes, and the business has so notified its insurance carrier. For information on California workers\u2019 compensation insurance, click ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://www.edd.ca.gov/disability/Employers_and_Self-Employed_Information.htm', target: '_blank', rel: 'noopener noreferrer' },
	                  'here'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer pays state unemployment insurance or elects the reimbursement method.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer pays any local city-imposed payroll tax.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer obtains a completed federal ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.uscis.gov/i-9', target: '_blank', rel: 'noopener noreferrer' },
	                  'Form I-9'
	                ),
	                ' from all new employees.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://www.edd.ca.gov/payroll_taxes/new_hire_reporting.htm', target: '_blank', rel: 'noopener noreferrer' },
	                  'reports'
	                ),
	                ' all newly hired employees to the EDD.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer notifies employees about the Earned Income Credit.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer obtains a completed ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.irs.gov/uac/about-form-w4', target: '_blank', rel: 'noopener noreferrer' },
	                  'IRS Form W-4'
	                ),
	                ' and ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://www.edd.ca.gov/payroll_taxes/forms_and_publications.htm', target: '_blank', rel: 'noopener noreferrer' },
	                  'state Form DE 4'
	                ),
	                ' from each employee.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer furnishes each employee with a completed ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.irs.gov/uac/about-form-w2', target: '_blank', rel: 'noopener noreferrer' },
	                  'IRS Form W-2'
	                ),
	                ' by January 31 for the previous calendar year.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer posts or provides to all employees the required employment notices.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer complies with wage and hours laws, workplace safety laws, and nondiscrimination laws.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer complies with all employee benefit plan requirements.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer complies with all written personnel policies and procedures.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer prepares proper documentation of all independent contractor arrangements, and reports compensation to independent contractors on ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.irs.gov/uac/about-form-1099misc', target: '_blank', rel: 'noopener noreferrer' },
	                  'IRS Form 1099 MISC'
	                ),
	                ' and ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://www.edd.ca.gov/Payroll_Taxes/Independent_Contractor_Reporting.htm', target: '_blank', rel: 'noopener noreferrer' },
	                  'California Form DE 542'
	                ),
	                ' .'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'If it employs greater than 50 employees, the employer offers affordable health care or pays a fee. For additional help with employer legal compliance, click ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://www.edd.ca.gov/Employer_Services.htm', target: '_blank', rel: 'noopener noreferrer' },
	                  'here'
	                ),
	                '.'
	              )
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Setting Up an Employee Relationship'
	            ),
	            _react2.default.createElement(_MaterialTable2.default, { title: 'Setting Up an Employee Relationship',
	              headElements: ['Level of Compliance', 'Requirements'],
	              rowElements: [['Meets Government Requirements', 'See Legal Compliance Checklist above'], ['Minimally Necessary', 'Have an application process, interview the candidates, check references, use an offer letter, and supervise them carefully'], ['Optimal', 'Have personnel policies, and use a payroll service to assist with handling logistics']] }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Template Forms'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Orrick: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.orrick.com/Total-Access/Tool-Kit/Start-Up-Forms/Employment-and-Consultant', target: '_blank', rel: 'noopener noreferrer' },
	                  'Startup Forms Library - Employee Offer Letter'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Nolo (via SF Law Library: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://sflawlibrary.org/legal-databases#Nolo%20Legal%20Information%20Reference%20Center', target: '_blank', rel: 'noopener noreferrer' },
	                  'Nolo Legal Information Reference Center - Human Resources'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Clerky: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://handbook.clerky.com/formation/83b-elections', target: '_blank', rel: 'noopener noreferrer' },
	                  '83(b) Elections'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Clerky: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://help.clerky.com/article/1716-how-do-i-make-an-83-b-election', target: '_blank', rel: 'noopener noreferrer' },
	                  '83(b) Elections (Step-by-Step)'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              { id: 'interns-or-volunteers', className: 'anchor-ref' },
	              'Interns or Volunteers'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Nonprofit Organizations'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'It is generally accepted that most nonprofit organizations cannot operate without the help of volunteers. Additionally, as you might remember from the ',
	              _react2.default.createElement(
	                'a',
	                { href: '/entity-formation/' },
	                'Entity Formation'
	              ),
	              ' module, nonprofit organizations must adhere to rules against providing a substantial private benefit\u2014nonprofits must work toward public or charitable purposes that benefit society as a whole, and not to the benefit of just a few particular individuals. Based on these reasons, unpaid interns or volunteers in a nonprofit organization generally wouldn\'t raise red flags among the employment authorities.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'One exception, however, is in the context of the limited commercial activities that a nonprofit organization may perform. For example, if the nonprofit runs a gift shop, the workers who staff the gift shop cannot be ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.dol.gov/whd/regs/compliance/whdfs14a.pdf', target: '_blank', rel: 'noopener noreferrer' },
	                'volunteers'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'For-Profit Organizations'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Because for-profit companies, by definition, work toward maximizing profit for their shareholders, volunteers and unpaid interns working within for-profit businesses are viewed as more exploitative than beneficial. As a result, unpaid worker relationships (volunteers and unpaid interns) in for-profit businesses are highly scrutinized by the Department of Labor.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'In fact, the ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.dol.gov/whd/regs/compliance/whdfs71.pdf', target: '_blank', rel: 'noopener noreferrer' },
	                'guidelines'
	              ),
	              ' put forth by the Department of Labor are designed to make interns more trouble than they\'re worth in a for-profit business. This is to ensure that the internship is primarily operated as an educational program for the benefit of the intern trainee. Some key highlights from the guidelines include:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'The training is similar to that found in a vocational school;'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The intern does not displace regular employees; and'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The employer derives no immediate advantage from the activities of the intern.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Given these requirements, most early stage start-up companies would probably be hard-pressed to design and implement a compliant unpaid internship program. One avenue that might be helpful is to engage with an academic institution to set up a system where interns receive course credit for participating in the internship. This would require additional coordination with the school/university, but often helps ensure that the internship is primarily focused on benefiting the intern.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Setting Up an Intern/Volunteer Relationship'
	            ),
	            _react2.default.createElement(_MaterialTable2.default, { title: 'Setting Up an Intern/Volunteer Relationship',
	              headElements: ['Level of Compliance', 'Requirements'],
	              rowElements: [['Meets Government Requirements', 'For-profit employers must meet the test for an unpaid internship (see Department of Labor guidelines above)'], ['Minimally Necessary', 'Set expectations in a written contract and hold an orientation session'], ['Optimal', 'Anticipate issues regarding supervision and liability']] }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Template Forms'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'New Business Community Law Clinic: ',
	                _react2.default.createElement(_TermsModal2.default, { link: 'https://drive.google.com/open?id=0B9zW8ghngOP2NEdJR0lxSXhVSDA', text: 'Template - Unpaid Internship Agreement' })
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              { id: 'footnotes', className: 'anchor-ref' },
	              'Footnotes'
	            ),
	            _react2.default.createElement(_FootnotesList2.default, { footnotes: footnotes })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = OperationalRelationshipsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-operational-relationships-js-c9a142cae78336f79fc5.js